// @flow
import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useUserTimeZone from 'app/common/hooks/useUserTimeZone';
import RowLayout, { Header } from 'app/common/layouts/RowLayout';
import PlainButton from 'app/common/ui-next/plain-button';

import Order from './Order';
import PaymentFrame from './PaymentFrame';


type Props = {
  orderId: string,
  number: string,
  onReturnToOrdersHistory: () => void,
}

const OrderPayment = ({
  orderId,
  number,
  onReturnToOrdersHistory,
}: Props) => {
  const { t } = useTranslation('shop');
  const [timezone, loadingTimezone] = useUserTimeZone();

  const [reloadOscilator, setReloadOscilator] = useState();
  const toggleReload = useCallback(() => {
    setReloadOscilator(current => !current);
  }, []);

  return (
    <React.Fragment>
      <RowLayout flex>
        <Header>{t('order_payment_header')}</Header>
        <PlainButton onClick={onReturnToOrdersHistory}>
          {t('order_payment_return_to_history_bt')}
        </PlainButton>
      </RowLayout>
      <Order
        id={orderId}
        number={number}
        timezone={timezone}
        loading={loadingTimezone}
        reloadOscilator={reloadOscilator}
        noIntroSpace
        hideButtons
      />
      <PaymentFrame
        orderId={orderId}
        onFrameUpdate={toggleReload}
      />
    </React.Fragment>
  );
};

export default OrderPayment;
